import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { map } from 'rxjs';

import {
  MobiUiIconComponent,
  MobiUiPopoverComponent,
  MobiUiPopoverDirective,
  MobiUiRadioButtonComponent,
  MobiUiRadioButtonGroupComponent,
} from '@mobi/rwc-ui-components-ng-jslib';
import { AuthenticationService } from '@mobi/rwc-utils-authentication-jslib';
import { ImpersonationService } from '@mobi/rwc-utils-ng-jslib';

@Component({
  selector: 'app-test-user-selection',
  imports: [
    // vendor
    AsyncPipe,

    // ui components
    MobiUiPopoverComponent,
    MobiUiIconComponent,
    MobiUiPopoverDirective,
    MobiUiRadioButtonComponent,
    MobiUiRadioButtonGroupComponent,
  ],
  templateUrl: './test-user-selection.html',
  styleUrls: ['./test-user-selection.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TestUserSelection {
  #impersonationService = inject(ImpersonationService);
  #authenticationService = inject(AuthenticationService);

  protected readonly allowedTestUsers$ =
    this.#impersonationService.allowedTestUsers$;
  protected readonly activeUserId$ = this.getAccessTokenParsed().pipe(
    map(
      (token: any) =>
        `${token?.given_name} ${token?.family_name} (${
          token?.preferred_username
        }) ${token?.partner_fachnummer} ${token?.partner_name || ''} (${
          token?.cnumber
        })`
    )
  );

  protected async handleValueChange(
    userId: string | undefined,
    popOver: MobiUiPopoverDirective
  ): Promise<void> {
    if (userId) {
      await this.#impersonationService.switchUser(userId);
      popOver.closePopover();
    }
    return Promise.resolve();
  }

  private getAccessTokenParsed() {
    return this.#authenticationService.getAccessToken().pipe(
      map((token) => {
        if (token) {
          const base64Url = token?.split('.')[1];
          const base64 = base64Url?.replace(/-/g, '+').replace(/_/g, '/');
          const jsonPayload = JSON.parse(
            decodeURIComponent(escape(window.atob(base64)))
          );
          return jsonPayload;
        }
        return null;
      })
    );
  }
}
